import React, { useState, useEffect, useMemo } from 'react';
import { 
  LayoutDashboard, Users, Package, FileText, Settings as SettingsIcon, Plus, Search, Trash2, 
  Save, X, Mail, Phone, DollarSign, ChevronLeft, Filter, Upload, Edit, Download, Database, 
  RefreshCw, Globe, User, CheckCircle, Send, ArrowLeft, ArrowRight, BarChart3, LogOut, Shield, 
  Cloud, FileSpreadsheet, Loader, Copy, Sun, Moon, MessageCircle, FileX, Bell, Clock, 
  AlertCircle, Check, MapPin, Hash, UserCheck, Smartphone, Tag
} from 'lucide-react';
import { THEMES, HOSTINGER_API_URL, CATEGORY_SORT_ORDER, DEFAULT_CATEGORIES, DEFAULT_TERMS, COMPANY_INFO, STATUS_OPTIONS } from '../config/constants';
import { apiCall } from '../services/api';

const Button = ({ children, variant = 'primary', onClick, className = "", type="button", disabled, theme, ...props }) => {
  const variants = {
    primary: "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/20 hover:shadow-blue-500/30 hover:-translate-y-0.5 disabled:opacity-50 disabled:translate-y-0",
    secondary: "bg-gradient-to-r from-orange-400 to-orange-500 text-white shadow-lg shadow-orange-500/20 hover:shadow-orange-500/30 hover:-translate-y-0.5 disabled:opacity-50 disabled:translate-y-0",
    outline: `border ${theme === 'dark' ? 'border-slate-600 text-slate-300 hover:bg-slate-800' : 'border-slate-300 bg-white/40 backdrop-blur text-slate-700 hover:bg-white/60'} hover:shadow-sm`,
    ghost: `${theme === 'dark' ? 'text-slate-400 hover:bg-slate-800 hover:text-white' : 'text-slate-500 hover:bg-black/5 hover:text-slate-800'}`,
    danger: "bg-red-50 text-red-600 hover:bg-red-100 border border-red-100",
  };
  
  if (theme === 'dark' && variant === 'primary') {
    variants.primary = "bg-gradient-to-r from-white to-slate-200 text-slate-900 hover:shadow-lg hover:shadow-white/10";
  }

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={`px-5 py-3 rounded-2xl text-sm font-semibold transition-all duration-300 flex items-center justify-center gap-2 active:scale-95 ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button;
